<script setup lang="ts" generic="T extends Array<Record<string, any>>">
const props = defineProps<{ items: T }>();
</script>

<template>
    <div class="mt-10">
        <div class="w-full flex flex-col gap-10">
            <div
                v-for="item in props.items"
                :key="item.title"
                class="w-full flex flex-col items-center gap-10"
            >
                <div class="w-10 h-10 flex-center bg-secondary-600 rounded-full -mb-6">
                    <Icon :name="item.icon" size="24" class="text-white" />
                </div>
                <h3 class="text-center">{{ item.title }}</h3>
                <p v-html="item.desc" class="text-body2 text-gray-400" />
                <img 
                    :src="item.img"
                    :alt="item.title"
                    loading="lazy"
                    class="w-full -mt-6"
                />
            </div>
        </div>
    </div>
</template>